import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.scss']
})
export class SendMessageComponent implements OnInit {

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  formGroup:any;

  error = false;

  alert:any;

  sent = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.reset();

  }

  submitForm(){
    this.submitted = true;
    if (this.formGroup.valid) {

      let message = this.formGroup.value;
      //console.log({messages:message});

      this.okService.put("account/sendmessage",{message:message})
      .subscribe((data:any) => {

        if(data.body['error']){
          this.alert = {"type":"error","content":data.body['error']};
        }else{
          this.sent = true;
          this.alert = {"type":"success","content":data.body};
        }

        


      });

      
    }
  }

  reset(){
    this.formGroup = new FormGroup({
      content: new FormControl('',[Validators.required]),
      groups: new FormControl([],[]),
      type: new FormControl('',[Validators.required]),
      status: new FormControl('on_shift',[Validators.required]),
      who: new FormControl('workers',[Validators.required]),
    });
    this.sent = false;
    this.submitted = false;
    this.alert = null;
  }

}
